export*from"./use-local-storage";export*from"./use-session-storage";
//# sourceMappingURL=index.js.map
